import React from 'react';
import InvoicesPresentational from './invoices-presentational';

const InvoicesFunctional = () => {
	return <InvoicesPresentational />;
};

export default InvoicesFunctional;
